import { Row, Col } from "antd";
import React from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import CodeSyntaxHighlighter from "../../../../../component/syntax-highlighter";

export default function InstallByPackage() {
  return (
    <Row gutter={[24, 24]}>
      <Col xs={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <p className="w-font-md fw-600 color-text-secondary">
              1. Install dependency
            </p>
          </Col>
          <Col xs={24}>
            <CodeSyntaxHighlighter code={`npm install @waxio/widget-marketplace`} />
          </Col>
        </Row>
      </Col>

      <Col xs={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <p className="w-font-md fw-600 color-text-secondary">
              2. Import the script (ES6)
            </p>
          </Col>
          <Col xs={24}>
            <CodeSyntaxHighlighter
              code={`import WaxMarketPlace from '@waxio/widget-marketplace';`}
            />
          </Col>
        </Row>
      </Col>

      <Col xs={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <p className="w-font-md fw-600 color-text-secondary">
              3. Place embed
            </p>
          </Col>
          <Col xs={24}>
            <CodeSyntaxHighlighter
              code={`<WaxMarketPlace collections='your-collections-name' itemPerPage={12}/>`}
            />
          </Col>
        </Row>
      </Col>

      <Col xs={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <p className="w-font-md fw-600 color-text-secondary">4. Done!</p>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
